"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserUtil_1 = __importDefault(require("./BrowserUtil"));
//TODO review whether it can be merged to BrowserUtil
var UrlUtil = /** @class */ (function () {
    function UrlUtil() {
    }
    UrlUtil.getUrlParameter = function (name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(BrowserUtil_1.default.getSearch());
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
    UrlUtil.getHref = function () {
        if (!BrowserUtil_1.default.isBrowser())
            return '';
        return BrowserUtil_1.default.getHref();
    };
    UrlUtil.getPath = function () {
        return BrowserUtil_1.default.getPath();
    };
    UrlUtil.getSearch = function () {
        return BrowserUtil_1.default.getSearch();
    };
    UrlUtil.addUrlParameterToHref = function (parameterName, parameterValue) {
        var href = UrlUtil.getHref();
        var params = parameterName + "=" + encodeURIComponent(parameterValue);
        if (href.indexOf('?') > -1) {
            return href + '&' + params;
        }
        else {
            return href + '?' + params;
        }
    };
    //https://stackoverflow.com/questions/5999118/how-can-i-add-or-update-a-query-string-parameter
    UrlUtil.updateQueryStringParameter = function (uri, key, value) {
        var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        var separator = uri.indexOf('?') !== -1 ? '&' : '?';
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + '=' + encodeURIComponent(value) + '$2');
        }
        else {
            return uri + separator + key + '=' + encodeURIComponent(value);
        }
    };
    UrlUtil.replaceOrAddUrlParameterToHref = function (parameterName, parameterValue) {
        return UrlUtil.updateQueryStringParameter(UrlUtil.getHref(), parameterName, parameterValue);
    };
    return UrlUtil;
}());
exports.default = UrlUtil;
//# sourceMappingURL=UrlUtil.js.map